import Vue from 'vue';
import MessageComponent from './Tip.vue';
let MessageConstructor = Vue.extend(MessageComponent);

let instance;

const Loading = function (options = {}) {
	instance = new MessageConstructor({
		data: options
	});
	instance.$mount();
	document.body.appendChild(instance.$el);
	return instance;
}


export default Loading;


// WEBPACK FOOTER //
// ./src/components/element/tip/tip.js